/** @typedef {import('@/types/shipping.models').ParcelDirection} ParcelDirection */
/** @typedef {import('@/types/shipping.models').ShippingMethodChargingType} ShippingMethodChargingType */

import i18n from '@/i18n/i18n'
import { helpers } from '@vuelidate/validators'

export const /** @type {ParcelDirection} */ DIRECTION_INCOMING = 'i'
export const /** @type {ParcelDirection} */ DIRECTION_OUTGOING = 'o'
export const /** @type {ParcelDirection} */ DIRECTION_FOLLOW_UP = 'f'

export const /** @type {ShippingMethodChargingType} */ CHARGED_ON_SCAN = 'first_scan'
export const /** @type {ShippingMethodChargingType} */ CHARGED_ON_CREATE = 'label_creation'

const outgoingObject = {
  id: DIRECTION_OUTGOING,
  name: i18n.t('Outgoing shipments'),
}

const incomingObject = {
  id: DIRECTION_INCOMING,
  name: i18n.t('Incoming returns'),
}

export const DIRECTION_CHOICES = [outgoingObject, incomingObject]

export const DIRECTION_MAP = {
  DIRECTION_OUTGOING: outgoingObject,
  DIRECTION_INCOMING: incomingObject,
}

export const PARCEL_STATUS_ID = {
  READY_TO_SEND: 1000,
  ANNOUNCED: 1,
  TO_SORTING: 3,
  DELAYED: 4,
  SORTED: 5,
  UNSORTED: 6,
  SORTING: 7,
  DELIVERY_FAILED: 8,
  DELIVERY_FORCED: 10,
  DELIVERED: 11,
  AWAITING_CUSTOMER_PICKUP: 12,
  ANNOUNCED_UNCOLLECTED: 13,
  COLLECT_ERROR: 15,
  UNSORTED2: 18,
  UNDELIVERABLE: 80,
  SHIPMENT_ON_ROUTE: 91,
  DRIVER_ON_ROUTE: 92,
  PICKED_UP_BY_DRIVER: 22,
  COLLECTED_BY_CUSTOMER: 93,
  NO_LABEL: 999,
  ANNOUNCING: 1001,
  CANCELLING_UPSTREAM: 2001,
  CANCELLING: 1999,
  CANCELLED: 2000,
  CANCELLED_UPSTREAM: 1998,
  UNKNOWN: 1337,
  ANNOUNCEMENT_FAILED: 1002,
}

export const PARCEL_STATUS_GROUPS = {
  READY_TO_SEND: [PARCEL_STATUS_ID.READY_TO_SEND, PARCEL_STATUS_ID.ANNOUNCED, PARCEL_STATUS_ID.ANNOUNCED_UNCOLLECTED],
  IN_TRANSIT: [
    PARCEL_STATUS_ID.TO_SORTING,
    PARCEL_STATUS_ID.SORTED,
    PARCEL_STATUS_ID.UNSORTED,
    PARCEL_STATUS_ID.SORTING,
    PARCEL_STATUS_ID.DELIVERY_FAILED,
    PARCEL_STATUS_ID.COLLECT_ERROR,
    PARCEL_STATUS_ID.UNSORTED2,
    PARCEL_STATUS_ID.UNDELIVERABLE,
    PARCEL_STATUS_ID.SHIPMENT_ON_ROUTE,
    PARCEL_STATUS_ID.PICKED_UP_BY_DRIVER,
    PARCEL_STATUS_ID.DRIVER_ON_ROUTE,
    PARCEL_STATUS_ID.AWAITING_CUSTOMER_PICKUP,
    PARCEL_STATUS_ID.DELAYED,
  ],
  DELIVERED: [PARCEL_STATUS_ID.DELIVERED, PARCEL_STATUS_ID.DELIVERY_FORCED, PARCEL_STATUS_ID.COLLECTED_BY_CUSTOMER],
  NOT_ANNOUNCED: [PARCEL_STATUS_ID.NO_LABEL, PARCEL_STATUS_ID.ANNOUNCEMENT_FAILED],
  CANCEL: [PARCEL_STATUS_ID.CANCELLING_UPSTREAM, PARCEL_STATUS_ID.CANCELLING, PARCEL_STATUS_ID.CANCELLED],
  UNKNOWN: [PARCEL_STATUS_ID.UNKNOWN],
}

export const LETTER_SHIPPING_METHOD_ID = 8

export const SERVICE_POINT_INPUT = {
  NONE: 'none',
  REQUIRED: 'required',
  OPTIONAL: 'optional',
}

export const INTEGRATION_TYPE_CODE_MAGENTO_V2 = 'magento_v2'
export const INTEGRATION_TYPE_CODE_SALESFORCE_COMMERCE_CLOUD = 'sfcc'
export const INTEGRATION_TYPE_CODE_WOOCOMMERCE = 'woocommerce'
export const INTEGRATION_TYPE_CODE_SENDCLOUD_API = 'api'
export const INTEGRATION_TYPE_CODE_TEMPLATES = 'templates'

export const DATE_RANGE_PARCEL_FILTER = {
  id: 'daterange',
  type: 'daterange',
  name: i18n.t('Label creation date'),
  value: {
    start_date: null,
    end_date: null,
  },
}

export const pricingPilotGroups = ['free', 'lite', 'growth', 'premium']

/**
 * Mapping logic to determine whether a proof of delivery document
 * may be requested for a given parcel.
 *
 * The key accepts the carrier code and the value is an array of
 * eligible from_country ISO2 codes.
 */
export const PROOF_OF_DELIVERY_ELIGIBLE_PARCELS = {
  dpd: ['NL', 'BE', 'DE'],
  dpd_at: ['AT', 'DE'],
}

export const phoneNumberValidator = helpers.regex(/^[-+ 0-9]*$/)

export const LABEL_PRICE_BREAKDOWN_TYPE = {
  LABEL: 'price_without_insurance',
  INSURANCE: 'insurance_price',
  FUEL_SURCHARGE: 'fuel',
}
